import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import { parseDate } from 'models/utils'

import styles from './NotesWidget.module.sass'

const ReminderRow = (props) => {
	const { reminder } = props
	const { processId, note } = reminder

	return (
		<HStack
			className={styles['reminder-row']}
			align='center'
			wrap='nowrap'
			columns={processId ? [0, 5, 1] : [0, 1]}
			gap='xsmall'
			justify='space-between'
		>
			<span className={styles['pill']} />
			<Tooltip
				className={styles['note-container']}
				content={
					<small className={styles['note-tooltip']}>{note}</small>
				}
				displayDelay={700}
			>
				<small>{note}</small>
			</Tooltip>
			{processId && (
				<Link to={`/clinical-processes/${processId}/appointments`}>
					<small>#{processId}</small>
				</Link>
			)}
		</HStack>
	)
}

const RemindersWidget = (props) => {
	const { reminders } = props
	const { i18n } = useGlobal()
	const todayDate = parseDate(new Date())

	return (
		<ExpandableWidget
			className={styles['root']}
			titleAppearance='no-line'
			heading='h5'
			title={i18n`Today, ${todayDate.separatedDateFormat.day} of ${todayDate.separatedDateFormat.fullMonth}`}
			expanded
			borderRadius
			paddings={['', 'xsmall', 'xsmall']}
			margins={['small', '', '']}
		>
			{reminders?.length ? (
				reminders.map((reminder) => (
					<ReminderRow key={reminder.id} reminder={reminder} />
				))
			) : (
				<div
					className={styles['no-reminders']}
				>{i18n`There are no reminders for today.`}</div>
			)}
		</ExpandableWidget>
	)
}

export default RemindersWidget
